import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class LoaderHideComponent extends BridgeComponent {
    static component = "loaderhide";

    connect() {
        super.connect();
        var cartCount = localStorage.getItem("cartCount") || 0;
        this.send("connect", { cart: cartCount }, () => {
            console.log("📨 Loader Hide:", response);
            this.element.click();
        });
    }

    loaderHide() {
        var cartCount = localStorage.getItem("cartCount") || 0;
        // This method can be used to trigger cart-related actions.
        this.send("loaderhide", { cart: cartCount }, (response) => {
            console.log("📨 Loader Hide:", response);
        });
    }
}
export default LoaderHideComponent;
